import React, { useEffect, useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { PaperAirplaneIcon, SearchIcon } from '@heroicons/react/solid';
import { ComplaintServices } from '../../services/CompliantServices';
import {  DisplayTime, isToday } from '../../utils/convertDate';
import { convert, pascalCASE } from './../../utils/convertDate';

export default function Complaint() {
    const [chat, setChat] = useState([]);
    const [ticketId, setText] = useState("");
    const [interval, setInterval] = useState("")
    const [formValues, setFormValues] = useState({
        message: ""
    })
    const [conservations, setConversations] = useState([]);
    const [user, setUser] = useState({ firstName: "", surname: "" });
    const [customerDetails, setCustomerDetails] = useState({
        customer: {
            firstName: "",
            lastName: ""
        }
    });
    const statusStyles = {
        New: 'admin-darker mb-2',
        Staff: "justify-end"
    }
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    const conversation = async (id) => {
        setText(id);
        getTicketDetails(id);
        var details = sessionStorage.getItem("user");
        var userDetails = JSON.parse(details);
        console.log("user", userDetails)
        setUser(userDetails);
    }
    const addConversation = async () => {
        if (formValues.message !== "") {
            const resp = await ComplaintServices.addConversation(
                {
                    message: formValues.message,
                    ticketId: ticketId
                }
            );
            if (resp.status) {
                conservations.push({
                    replyType: "Staff",
                    createdOn: new Date().toISOString(),
                    message: formValues.message
                })
                setConversations(conservations);
                var chatIndex = chat.findIndex(x => x.ticketId === ticketId);
                chat[chatIndex].ticketStatus = "Open";
                setChat(chat);
                setFormValues({ message: "" })

            }
        }
    }
    const validation = {
        messageHandler: (event) => {
            setFormValues({ ...formValues, message: event.target.value });
        }
    }
    const getTicketDetails = async (id) => {
        const resp = await ComplaintServices.getTicketDetails(id);
        setInterval();
        if (resp) {
            setConversations([...resp?.data.conversations]);
            setCustomerDetails(resp?.data);
            const testInterval = setInterval(() => {
                getConversations(id)
            }, 5000);
            var chatIndex = chat.findIndex(x => x.ticketId === id);
            chat[chatIndex].ticketStatus = "Open";
            setChat(chat);
        }
    }
    const getConversations = async (id) => {
        const resp = await ComplaintServices.listConversations(id);
        if (resp?.data.length !== 0) {
            conservations.push([...resp?.data]);
            setConversations(conservations);
        }
        
    }
    const list = async () => {
        const resp = await ComplaintServices.listComplaints();
        setChat([...resp?.data]);
     
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    useEffect(() => {
        const timer = window.setInterval(() => {
            list(); 
        }, 2000);
        return () => {
            window.clearInterval(timer);
        };

    }, []);

   
    return (
        <>
            <Layout title={"Chat"} current={"/complaints"} pageTag={"compliant"}>
                <React.Fragment>
                    <main className="min-w-0 flex-1  border-gray-200 lg:flex  h-96">
                        {/* Primary column */}
                        <section
                            aria-labelledby="primary-heading"
                            className="flex h-96 min-w-0 flex-col  lg:order-last overflow-y"
                            style={{ width: "30rem" }}
                        >

                            <div className="ml-2">
                                <div style={{ width: "30rem" }} className="flex justify-between">
                                    {/* message */}
                                    <div>
                                        {ticketId !== "" ? <div className="flex justify-between" style={{ width: "30rem" }}>
                                            <div className="min-w-0 flex-1 flex">
                                                <div
                                                    className="text-center mt-2 font-extrabold bg-black h-10 w-10 rounded-full mr-2">
                                                    <p className='text-white mt-2'> {customerDetails.customer.firstName.charAt(0)} {customerDetails.customer.lastName.charAt(0)}</p>
                                                </div>                                                <div>
                                                    <p className="text-sm font-medium text-gray-900 truncate">{customerDetails.customer.firstName} {customerDetails.customer.lastName} <span className='text-red-400'>({customerDetails.customer.emailAddress})</span></p>
                                                    <p className="text-sm text-gray-500 truncate">{customerDetails.subject}</p>
                                                </div>

                                            </div>
                                        </div> : ""}

                                        {/* reply template */}



                                        {ticketId && <>
                                            <div className='demoScroll sc2' style={{ height: "17.4rem", overflow: "overlay" }}>
                                                {conservations.map((resp, i) => (

                                                    <div key={i} className={classNames(
                                                        statusStyles[resp.replyType], "flex")}>
                                                        {resp.replyType === "Customer" ?
                                                            <div className="flex mt-5 ml-2">
                                                                <div
                                                                    className="text-center mt-2 font-extrabold bg-black h-8 w-8 rounded-full mr-2">
                                                                    <p className='text-white mt-2 text-sm'> {customerDetails.customer.firstName.charAt(0)} {customerDetails.customer.lastName.charAt(0)}</p>
                                                                </div>
                                                                <div>
                                                                    <div className='customer-chat' style={{ borderTopRightRadius: "10px" }}>
                                                                        <p className='text-sm'>{resp.message}</p>
                                                                    </div>
                                                                    <span className=" text-left mt-1 text-xs">{DisplayTime(resp.createdOn)}</span>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="flex mt-5  justify-end mr-5">
                                                                <div className='mr-1'>
                                                                    <div className='admin-darker text-xs ' style={{ borderTopLeftRadius: "10px" }}>
                                                                        <p >{resp.message}</p>
                                                                    </div>
                                                                    <span className="text-right justify-end flex mt-1 text-xs">{DisplayTime(resp.createdOn)}</span>
                                                                </div>
                                                                <div
                                                                    className="text-center font-extrabold bg-black h-8 w-8 rounded-full mr-2">
                                                                    <p className='text-white mt-2 p text-xs'> {user.firstName.charAt(0)} {user.surname.charAt(0)}</p>
                                                                </div>
                                                            </div>
                                                        }

                                                    </div>

                                                ))}
                                            </div>
                                            <div className="mt-5  rounded-md shadow-sm ml-2">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="relative flex flex-grow items-stretch focus-within:z-10">
                                                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                        </div>
                                                        <input
                                                            type="text"
                                                            name="comment"
                                                            id="comment"
                                                            value={formValues.message}
                                                            onChange={validation.messageHandler}
                                                            className=" block w-full rounded-none pr-10 sm:text-sm border-gray-300 focus:unset"
                                                            placeholder="Write a message... "
                                                        />
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={addConversation}
                                                        className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium  text-white bg-blue-600 hover:bg-gray-100 hover:text-gray-300 "
                                                    >
                                                        <PaperAirplaneIcon className="h-5 w-5 text-white hover:text-gray-300 slant_text" aria-hidden="true" />
                                                    </button>
                                                </div>
                                               

                                            </div>
                                        </>}
                                        <div>
                                           
                                        </div>

                                    </div>

                                </div>
                            </div>
                            {/* Your content */}
                        </section>

                        {/* Secondary column (hidden on smaller screens) */}
                        <aside className=" lg:order-first lg:block lg:flex-shrink-0">
                            <div className="relative flex h-full w-60 flex-col  border-r border-gray-200">
                                {/* Your content */}
                                <div className="demoScroll sc2"
                                >
                                    <div className="flex">
                                        <p className="mr-2">Inbox</p>
                                       
                                    </div>

                                    <div className="mt-5 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-none rounded-md"
                                            placeholder="Search ....."
                                        />
                                    </div>
                                    <div role="list" className="divide-y divide-gray-200">
                                        {chat.map((person, i) => (
                                            <button key={i} className={classNames(
                                                statusStyles[person.ticketStatus], "py-4 p-4 w-56")} onClick={() => conversation(person.ticketId)}>
                                                <div className='flex'>
                                                    <div
                                                        className="text-center mt-2 font-extrabold bg-black h-8 w-8 rounded-full mr-2">
                                                        <p className='text-white mt-2 text-xs'> {pascalCASE(person.customer.firstName.charAt(0))} {pascalCASE(person.customer.lastName.charAt(0))}</p>
                                                    </div>

                                                    <div className="mr-1">
                                                        <p className="text-xs font-bold text-left text-gray-900">{pascalCASE(person.customer.firstName)} {pascalCASE(person.customer.lastName)}</p>
                                                        <p className="text-sm text-gray-500 text-left">{person.subject}</p>
                                                    </div>
                                                    <div>
                                                        <p style={{ fontSize: "0.6rem" }} className="text-gray-500">{isToday(new Date(convert(person.createdAt))) === true ? DisplayTime(person.createdAt) : convert(person.createdAt)}</p>
                                                    </div>
                                                </div>

                                            </button>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </aside>
                    </main>
                    <div className='flex'>
                        <div className='w-72'> <p className='hidden'>ghjk</p></div>
                      
                    </div>

                </React.Fragment>
            </Layout>
        </>
    )
}